import styled, { css } from 'styled-components';

export const LoaderPseudoelementCSS = css`
  background-color: rgb(227, 227, 222);

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(185, 185, 172, 0) 0%,
      rgba(185, 185, 172, 0.15) 20%,
      rgba(185, 185, 172, 0.35) 60%,
      rgba(185, 185, 172, 0) 100%
    );
    animation: shimmer 1.5s infinite;
    content: '';

    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }
  }
`;

export const BackgroundLoader = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  ${LoaderPseudoelementCSS};
`;
